import { sqliteTable, text, integer } from "drizzle-orm/sqlite-core";
import { fleetVehicles } from "./vehicles";

// ============================================================================
// vehicle_images — รูปรถ
// ============================================================================
export const fleetVehicleImages = sqliteTable("fleet_vehicle_images", {
  id: text("id").primaryKey(), // ULID
  vehicleId: text("vehicle_id").notNull().references(() => fleetVehicles.id),
  imageUrl: text("image_url").notNull(),
  imageTypeId: text("image_type_id"), // FK → vehicle_image_types.id
  caption: text("caption"),
  sortOrder: integer("sort_order").notNull().default(0),
  createdAt: text("created_at").notNull(),
  createdBy: text("created_by"),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type FleetVehicleImage = typeof fleetVehicleImages.$inferSelect;
export type NewFleetVehicleImage = typeof fleetVehicleImages.$inferInsert;
